import React from 'react';
import { RegisterOptions } from 'react-hook-form';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { ILocation } from 'src/types/Location';
import { useLocationSearch } from 'src/utilities/useSearchHooks';
import {
  SelectSearchWrapper,
  SelectSearchWrapperProps,
} from 'src/components/SelectSearch/SelectSearchWrapper';

export interface BaseLocationsSelectSearchProps
  extends Pick<
    SelectSearchWrapperProps<ILocation, true>,
    | 'withApplyBtn'
    | 'maxSelectedItems'
    | 'header'
    | 'placeholder'
    | 'maxHeight'
    | 'initialSelectedValue'
  > {
  name: string;
  corpId: string;
  label?: string;
  rules?: RegisterOptions;
  onValueChange: (locations: ILocation[]) => void;
}

export function BaseLocationsSelectSearch({
  name,
  corpId,
  label,
  rules,
  placeholder = 'Select locations',
  maxHeight = '280px',
  initialSelectedValue,
  withApplyBtn = false,
  maxSelectedItems,
  header,
  onValueChange,
}: BaseLocationsSelectSearchProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <SelectSearchWrapper<ILocation, true>
      name={name}
      control={control}
      rules={rules}
      error={errors[name]}
      label={label}
      inputSize="medium"
      isMultiSelect
      corpId={corpId}
      maxHeight={maxHeight}
      displayProp="name"
      keyName="id"
      selectedItemLabel="location"
      selectedItemPluralLabel="locations"
      placeholder={placeholder}
      searchResource={useLocationSearch}
      initialSelectedValue={initialSelectedValue}
      onValueChange={onValueChange}
      withApplyBtn={withApplyBtn}
      maxSelectedItems={maxSelectedItems}
      header={header}
    />
  );
}
